import { render, staticRenderFns } from "./CargosSistema.vue?vue&type=template&id=f1116d66"
import script from "./CargosSistema.vue?vue&type=script&lang=ts"
export * from "./CargosSistema.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports